import { render, staticRenderFns } from "./FundBlock.vue?vue&type=template&id=a0a1d9aa"
import script from "./FundBlock.vue?vue&type=script&lang=js"
export * from "./FundBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports